import React from "react";
import {
  Animation,
  FORWARD,
  FORWARD_REVERSE,
} from "../AnimationRunner/AnimationRunner";
import bookAnim from "../../animations/book";
import bookEffect1 from "../../animations/bookEffect1";
import bookEffect2 from "../../animations/bookEffect2";
import canvasAnim from "../../animations/canvas";

export default function PhilosophyCanvasAnim() {
  return (
    <>
      <Animation
        animationData={bookAnim}
        className="absolute -left-4 top-0 w-80 h-80 hidden lg:block upDownAnimation"
        type={FORWARD}
        lineWidth={13}
      ></Animation>
      <Animation
        animationData={bookEffect1}
        className="absolute right-64 -top-16 w-72 h-72 hidden lg:block"
        lineWidth={13}
        type={FORWARD_REVERSE}
        delay={300}
      ></Animation>
      <Animation
        animationData={bookEffect2}
        className="absolute left-72 -bottom-16 w-72 h-72 hidden lg:block"
        lineWidth={13}
        type={FORWARD_REVERSE}
      ></Animation>
      <Animation
        animationData={canvasAnim}
        className="absolute -right-4 top-0 w-80 h-80 hidden lg:block upDownAnimation delay"
        type={FORWARD}
        lineWidth={13}
      ></Animation>
    </>
  );
}
